import React, { useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/elements/Button';
import Card from '../../components/elements/Card';
import GridCell from '../../components/elements/GridCell';
import ScrollToTop from '../../components/elements/ScrollToTop';
import FilterMerchantForm from '../../components/forms/FilterMerchantForm';
import IcAgent from '../../components/icons/IcAgent';
import IconArrowRight from '../../components/icons/IconArrowRight';
import { AppContext } from '../../contexts';
import { fetchSearchSettingMerchant, ResetRedux } from './actions';
import styles from './styles.scoped.css';
import { fetchSessionProtection } from '../../components/layouts/PageBase/actions';

function SettingMerchant() {
  const { setBreadcrumbs } = useContext(AppContext);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { search } = useSelector((s) => s.merchantSetting);

  const handledReset = () => {
    dispatch(ResetRedux());
  };

  useEffect(() => {
    dispatch(fetchSessionProtection());
    handledReset();
    setBreadcrumbs(['Data Pangkalan LPG 3 Kg']);
  }, []);

  const handleSubmit = (value) => {
    dispatch(fetchSearchSettingMerchant(value));
  };

  return (
    <main className={styles.root}>
      <Card className={styles.card}>
        <div className={styles.content}>
          <div>
            <img
              height="100"
              src="/assets/illu-setting-merchant.svg"
              width="100"
            />
          </div>
          <div className={styles.column}>
            <span>Cari data pangkalan</span>
            <span>Cari data pangkalan berdasarkan parameter tertentu</span>
            <FilterMerchantForm
              code={search?.code}
              handledReset={handledReset}
              handleSubmitMerchant={handleSubmit}
              message={search?.message}
            />
          </div>
        </div>
        {search?.data &&
        <div className={styles.contentDetail}>
          <div>
            <IcAgent />
            <span>{search.data?.storeName}</span>
          </div>
          <div>
            <GridCell data={search.data?.registrationId} label="ID Pangkalan" />
            <GridCell data={search.data?.registrationDate} label="Tanggal Registrasi" />
            <GridCell data={search.data?.registrationTime} label="Jam Registrasi" />
            <GridCell data={search.data?.midMap} label="MID" />
            <GridCell data={search.data?.phoneNumber} label="No. Handphone" />
            <GridCell data={search.data?.email} label="Email" />
          </div>
          <div>
            <Button
              className={styles.button}
              onClick={() =>
                navigate(`/merchant/setting-data-merchant/detail/${search.data?.userId}`)
              }
              style={'blue'}
            >
              <span>Lihat Rincian Data Pangkalan</span>
              <IconArrowRight />
            </Button>
          </div>
        </div>
        }
      </Card>
      <ScrollToTop />
    </main>
  );
}

export default SettingMerchant;
